import { ComponentType } from 'react';
import { FallbackProps } from 'react-error-boundary';

import { ErrorContainer, ErrorMessage, ErrorTitle } from './styled';

const ApplicationContentFallback: ComponentType<FallbackProps> = ({ error }): JSX.Element => (
  <ErrorContainer data-testid="applicationContentErrorBoundary">
    <ErrorTitle>Application Error</ErrorTitle>
    <ErrorMessage>The application has stopped responding unexpectedly.</ErrorMessage>
    <ErrorMessage>Come back to the page later or contact application administrator.</ErrorMessage>
    <ErrorMessage data-testid="applicationContentErrorBoundaryMessage">{error.message}</ErrorMessage>
  </ErrorContainer>
);

export default ApplicationContentFallback;
